import React from "react";
import { useSEO, breadcrumbSchema, SITE_URL } from "../lib/seo";

const PRIVACY = {
  title: "Privacy Policy",
  sections: [
    ["Who we are", "Alpha Community Care is an NDIS-registered provider delivering supported housing and community services across Australia."],
    ["What we collect", "We collect personal and sensitive information required to provide high quality NDIS supports, including identity details, NDIS plan details, and health information where relevant."],
    ["How we use it", "We use your information to deliver services, meet NDIS and regulatory obligations, and improve our programs. We will never sell your information."],
    ["How we protect it", "We use strong encryption at rest and in transit, role-based access controls, and regular security reviews."],
    ["Your rights", "You have the right to access, correct and request deletion of your information, subject to our regulatory obligations."],
    ["Contact", "For privacy requests, contact privacy@alphacommunitycare.com.au."],
  ],
};

const TERMS = {
  title: "Terms & Conditions",
  sections: [
    ["Website use", "This website is provided for information and to facilitate referrals and enquiries. Content is general in nature and not a substitute for individual advice."],
    ["Services", "Services are provided under a written service agreement that references the NDIS Practice Standards."],
    ["Intellectual property", "All content on this website is the property of Alpha Community Care unless otherwise indicated."],
    ["Liability", "To the maximum extent permitted by law, Alpha Community Care's liability is limited as set out in your service agreement."],
    ["Governing law", "These terms are governed by the laws of Victoria, Australia."],
  ],
};

export function PrivacyPage() {
  useSEO({
    title: "Privacy Policy | Alpha Community Care NDIS",
    description: "Alpha Community Care privacy policy — how we collect, use, store and protect participant and family information under the Privacy Act and NDIS Practice Standards.",
    canonical: `${SITE_URL}/privacy`,
    jsonLd: [breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Privacy Policy", path: "/privacy" }])],
  });
  return <Legal data-testid="page-privacy" doc={PRIVACY} />;
}
export function TermsPage() {
  useSEO({
    title: "Terms & Conditions | Alpha Community Care",
    description: "Terms of use for the Alpha Community Care website and services — website use, service agreements, intellectual property, liability and governing law.",
    canonical: `${SITE_URL}/terms`,
    jsonLd: [breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Terms", path: "/terms" }])],
  });
  return <Legal data-testid="page-terms" doc={TERMS} />;
}

function Legal({ doc }) {
  return (
    <div data-testid={`page-${doc.title.toLowerCase().replace(/\s+/g, "-")}`}>
      <section className="alpha-gradient-hero border-b border-[color:var(--alpha-line)]">
        <div className="alpha-container pt-14 pb-10">
          <div className="alpha-overline">Legal</div>
          <h1 className="mt-3 text-4xl sm:text-5xl font-display font-semibold tracking-tight">{doc.title}</h1>
        </div>
      </section>
      <section className="alpha-container py-14 max-w-3xl space-y-8">
        {doc.sections.map(([t, d]) => (
          <div key={t}>
            <h2 className="font-display text-xl font-semibold">{t}</h2>
            <p className="mt-2 text-[color:var(--alpha-mute)] leading-relaxed">{d}</p>
          </div>
        ))}
        <p className="text-xs text-[color:var(--alpha-mute)] pt-6 border-t border-[color:var(--alpha-line)]">Last updated: {new Date().toISOString().slice(0, 10)}</p>
      </section>
    </div>
  );
}
